<script>
  let { label, id, error = null, children, hint = null } = $props();

  let hintId = $derived(hint ? `${id}-hint` : null);
  let errorId = $derived(error ? `${id}-error` : null);
  let describedBy = $derived([hintId, errorId].filter(Boolean).join(' ') || undefined);
</script>

<div class="flex flex-col gap-1.5">
  <label for={id} class="text-sm font-semibold text-secondary-800">{label}</label>
  {@render children?.(describedBy)}
  {#if hint}<div id={hintId}>{@render hint()}</div>{/if}
  {#if error}
    <p id={errorId} class="text-sm text-red-600">{error}</p>
  {/if}
</div>
